import { ColumnDef } from "@tanstack/react-table";
import { TZDate } from "@date-fns/tz";
import { format } from "date-fns";
import { Badge } from "@/components/ui/badge";
import { RunSummary } from "@/client-admin/types.gen";
import { DataTableColumnHeader } from "../UserTable/data-table-column-header";

export const columns: ColumnDef<RunSummary>[] = [
  {
    accessorKey: "last_update",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Last Update (NL)" />,
    cell: ({ row }) => {
      const value = row.getValue("last_update") as string;
      return (
        <div className="whitespace-nowrap">{format(new TZDate(value, "Europe/Amsterdam"), "yyyy-MM-dd HH:mm")}</div>
      );
    },
    size: 145,
  },
  {
    accessorKey: "source",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Source" />,
    cell: ({ row }) => <div>{(row.getValue("source") as string) ?? "-"}</div>,
    size: 70,
  },
  {
    accessorKey: "algo_off",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Off" />,
    cell: ({ row }) => {
      const value = row.getValue("algo_off") as number;
      return (
        <Badge className="bg-gray-100 text-gray-800" variant="outline">
          {value}
        </Badge>
      );
    },
    size: 50,
  },
  {
    accessorKey: "algo_ready",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Ready" />,
    cell: ({ row }) => {
      const value = row.getValue("algo_ready") as number;
      return (
        <Badge className="bg-green-100 text-green-800" variant="outline">
          {value}
        </Badge>
      );
    },
    size: 55,
  },
  {
    accessorKey: "algo_built",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Built" />,
    cell: ({ row }) => {
      const value = row.getValue("algo_built") as number;
      return (
        <Badge className="bg-blue-100 text-blue-800" variant="outline">
          {value}
        </Badge>
      );
    },
    size: 50,
  },
  {
    accessorKey: "signal_count",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Signals" />,
    cell: ({ row }) => <div>{row.getValue("signal_count")}</div>,
    size: 60,
  },
  {
    id: "delivery_range",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Delivery" />,
    cell: ({ row }) => {
      const min = row.original.delivery_date_min;
      const max = row.original.delivery_date_max;
      if (min === max) return <div className="whitespace-nowrap">{min}</div>;
      return (
        <div className="whitespace-nowrap">
          {min} &rarr; {max}
        </div>
      );
    },
    size: 95,
  },
  {
    accessorKey: "total_buy_mwh",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Buy (MWh)" />,
    cell: ({ row }) => {
      const value = row.getValue("total_buy_mwh") as string;
      return <div className="whitespace-nowrap text-green-700">{value}</div>;
    },
    size: 90,
  },
  {
    accessorKey: "total_sell_mwh",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Sell (MWh)" />,
    cell: ({ row }) => {
      const value = row.getValue("total_sell_mwh") as string;
      return <div className="whitespace-nowrap text-red-700">{value}</div>;
    },
    size: 90,
  },
  {
    accessorKey: "created_at",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Received" />,
    cell: ({ row }) => {
      const value = row.getValue("created_at") as string;
      const utcValue = value.endsWith("Z") ? value : value + "Z";
      return <div className="whitespace-nowrap">{format(new Date(utcValue), "yyyy-MM-dd HH:mm:ss")}</div>;
    },
    size: 145,
  },
];
